import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class CargaService {
  url = `${this.env.URL_API}`;

  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  consultar(id): Observable<any> {
    return this.http.get(`${this.url}/carga/${id}`);
  }

  obtenerDatosCaso(id): Observable<any> {
    return this.http.get(`${this.url}/carga_casos/${id}`);
  }
  obtenerMallaCaso(id): Observable<any> {
    return this.http.get(`${this.url}/carga_casos/malla/${id}`);
  }
  obtenerMallaSake(id): Observable<any> {
    return this.http.get(`${this.url}/carga_casos/malla-individual/${id}`);
  }

  consultarCuenta(cuenta) {
    return this.http.get(`${this.url}/carga/consultarCuenta/${cuenta}`);
  }
  consultarPagoMovil(pago_movil: string) {
    return this.http.get(`${this.url}/carga/consultarPagoMovil/${pago_movil}`);
  }

  crearSakeYOperacion(json) {
    return this.http.post(`${this.url}/carga_casos/crearsake`, json);
  }
  crearOperacion(json) {
    return this.http.post(`${this.url}/carga_casos/crearoperacion`, json);
  }
  editarOperacion(json) {
    return this.http.post(`${this.url}/carga_casos/editaroperacion`, json);
  }
  eliminarOperacion(json) {
    return this.http.post(`${this.url}/carga_casos/eliminaroperacion`, json);
  }

  crear(body): Observable<any> {
    return this.http.post(`${this.url}/sakes`, body);
  }
  actualizar(body): Observable<any> {
    return this.http.put(`${this.url}/sakes/${body.id_sakes}`, body);
  }
  obtenerTodos(): Observable<any> {
    return this.http.get(`${this.url}/sakes`, { headers: this.headers });
  }
  eliminar(id): Observable<any> {
    const body = { body: { id_usuarios_creador: sessionStorage.getItem('id_usuario') }, headers: this.headers };
    return this.http.delete(`${this.url}/sakes/${id}`, body);
  }
}
